<template>
	<div>
		<div style="font-size:20px;float:left;margin:-35px 0 0 40px;font-weight:600">
			<img src="../../../assets/icon/返回.png" style="vertical-align: middle;margin-top:-2px" @click="close" />
			回款管理
		</div>
		<div style="background-color:white;margin:75px 40px 0 40px">
			<div style="padding:30px">
				<div style="background-color:#fdfdfd;padding:30px 50px;border:1px solid #f7f7f7">
					<div>
						<img src="../../../assets/icon/钱袋1￥.png" style="vertical-align: middle;margin-top:-3px" />
						<span style="color:#006E4B;font-size:18px;font-weight:600">履约金信息</span>
					</div>
					<div style="display:flex;margin-top:20px">
						<div class="text">
							<span>公司名头：</span><span>{{manageList.partnerName}}</span>
						</div>
						<div class="text">
							<span>组织架构：</span><span>{{$globals.group_name}}/{{manageList.organizeName}}</span>
						</div>
						<div class="text">
							<span>区域总管：</span><span>{{manageList.areaManagerName}}</span>
						</div>
						<div class="text">
							<span>项目名称：</span><span>{{manageList.projectName}}</span>
						</div>
					</div>
					<div style="display:flex;margin-top:20px">
						<div class="text">
							<span>履约金额：</span><span>{{manageList.money_amount}}</span>
						</div>
						<div class="text">
							<span>未回款金额：</span><span>{{manageList.uncollected_payment_money}}</span>
						</div>
						<div class="text">
							<span>是否散场备注：</span><span>{{''}}</span>
						</div>
						<div class="text">
							<span>收据情况：</span><span>{{manageList.is_receipt == '1'?'有' : '无'}}</span>
						</div>
					</div>
					<div style="display:flex;margin-top:20px">
						<div class="text">
							<span>备注：</span><span>{{manageList.spare}}</span>
						</div>
						<div class="text">
							<span>项目名称：</span><span>{{manageList.projectName}}</span>
						</div>
					</div>

				</div>
			</div>
			<div style="margin:0 2%;font-size: 18px;font-weight: 600;">付款记录</div>
			<div style="margin:-2% 2% 0 2%">
				<el-table ref="multipleTable" :header-cell-style="{background:'#ebf7f3',color:'#000000'}"
					:data="payData" tooltip-effect="dark" style="width: 100%" height="200"
					@selection-change="handleSelectionChange">
					<el-table-column label="序号" width="50">
						<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
					</el-table-column>
					<el-table-column prop="payment_time" label="付款时间" align="center">
					</el-table-column>
					<el-table-column prop="collection_voucher" label="付款凭证" align="center">
						<template slot-scope="scope">
							<img src="../../../assets/查看.png" @click="Voucher()" />
						</template>
					</el-table-column>
					<el-table-column prop="money_amount" label="付款金额" align="center">
					</el-table-column>
					<el-table-column prop="status" label="付款类别" align="center">
					</el-table-column>
				</el-table>
			</div>
			<div style="margin:10px 50px">
				<span style="margin-right:10px;margin-left:10px">回款日期</span>
				<el-date-picker style="width:25%" v-model="condition.start_date" type="datetimerange" clearable
					range-separator="至" start-placeholder="开始日期" format="yyyy-MM-dd HH:mm" end-placeholder="结束日期"
					value-format="yyyy-MM-dd HH:mm">
				</el-date-picker>
				<el-button style="width:85px;height:41px" type="goon" @click="Find">查询</el-button>
				<el-button style="width:135px;height:41px" type="goon" @click="Plan">回款计划登记</el-button>
			</div>
			<div style="margin:3% 2% 0 2%">
				<el-table ref="multipleTable" :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
					:data="tableData" tooltip-effect="dark" style="width: 100%" height="420"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"> </el-table-column>
					<el-table-column label="序号" width="50">
						<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
					</el-table-column>
					<el-table-column prop="estimate_collection_date" label="预计回款时间" align="center">
					</el-table-column>
					<el-table-column prop="estimate_collection_amount" label="预计回款金额" align="center">
					</el-table-column>
					<el-table-column prop="reality_collection_date" label="实际回款日期" align="center">
					</el-table-column>
					<el-table-column prop="reality_collection_amount" label="实际回款金额" align="center">
					</el-table-column>
					<el-table-column prop="collection_voucher" label="回款凭证" align="center" width="100">
						<template slot-scope="scope">
							<img src="../../../assets/查看.png" @click="Voucher()" />
						</template>
					</el-table-column>
					<el-table-column prop="spare" label="备注" align="center" width="100">
					</el-table-column>
					<el-table-column prop="applicantName" label="操作人" align="center">
					</el-table-column>
					<el-table-column prop="modified_time" label="操作时间" align="center">
					</el-table-column>
					<el-table-column label="操作" align="center" width="200">
						<template slot-scope="scope">
							<img src="../../../assets/icon/回款登记1.png" @click="Update(scope.row.id)" />
							<img src="../../../assets/icon/修改.png" @click="Revise(scope.row)" />
							<img src="../../../assets/icon/删除.png" @click="Del(scope.row.id)" />
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<el-row style=" margin-left: 500px;margin-top: -20px;">
					<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
						layout=" prev, pager, next, jumper" :total="total">
					</el-pagination>
				</el-row>
			</div>
			<el-dialog :title="plan.id == null || plan.id == '' ? '回款计划登记' : '回款计划修改'" :visible.sync="showPlan"
				width="30%" center="true" :close-on-click-modal="false">
				<div>
					<el-form label-position="right" label-width="120px" :model="formLabelAlign">
						<el-form-item label="预计回款时间">
							<el-date-picker style="width: 100%;" v-model="plan.estimate_collection_date" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="预计回款金额">
							<el-input type="number" v-model="plan.estimate_collection_amount" placeholder="请输入预计回款金额"></el-input>
						</el-form-item>
						<div style="text-align:center">
							<el-button type="goon" @click="PlanSave()" v-if="plan.id == null || plan.id == ''">保存
							</el-button>
							<el-button type="goon" @click="ReviseSave()" v-else>保存</el-button>
						</div>
						</el-button>
					</el-form>
				</div>
			</el-dialog>
			<el-dialog title="回款登记" :visible.sync="showRegister" width="30%" center="true"
				:close-on-click-modal="false">
				<div>
					<el-form label-position="right" label-width="120px" :model="formLabelAlign">
						<el-form-item label="实际回款时间">
							<el-date-picker style="width: 100%;" v-model="register.reality_collection_date" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="实际回款金额">
							<el-input type="number" v-model="register.reality_collection_amount" placeholder="请输入实际回款金额"></el-input>
						</el-form-item>
						<el-form-item label="回款凭证">
							<el-upload class="avatar-uploader" :action="$globals.http + '/file/upload'"
								:show-file-list="false" :on-success="handlePhotoSuccess">
								<img v-if="register.collection_voucher" :src="register.collection_voucher"
									class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
						<el-form-item label="备注">
							<el-input v-model="register.spare" placeholder="请输入备注"></el-input>
						</el-form-item>
						<div style="text-align:center">
							<el-button type="goon" @click="RegisterSave()">保存</el-button>
						</div>
						</el-button>
					</el-form>
				</div>
			</el-dialog>
		</div>

	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		props: ["manageList"],
		data() {
			return {
				ids: [],
				total: 0,
				input: '',
				showPlan: false,
				showRegister: false,
				ruleForm: {
					post_id: '',
				},
				//条件
				condition: {
					page_num: 1,
					page_size: 10,
					id: '',
					start_date: '',
					end_date: '',
					honour_id: '',
				},

				plan: {
					id: '',
					honour_id:'',
					tender_idtender_id: '',
					estimate_collection_date: '',
					estimate_collection_amount: '',
				},
				register: {
					applicant_id:'',
					id: '',
					collection_voucher: '',
					honour_id: '',
					reality_collection_date: '',
					reality_collection_amount: '',
					spare: '',
				},
				name: this.$globals.user.name,
				date: this.getNowTime(),
				multipleSelection: [],
				input: '',
				tableData: [],
				payData:[],

			};
		},

		mounted() {
			this.Find();
			this.payFind();
		},
		methods: {
			getNowTime() {
				var now = new Date();
				var year = now.getFullYear(); //得到年份
				var month = now.getMonth(); //得到月份
				var date = now.getDate(); //得到日期
				month = month + 1;
				month = month.toString().padStart(2, "0");
				date = date.toString().padStart(2, "0");
				var defaultDate = `${year}-${month}-${date}`;
				return defaultDate;
			},
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach((item) => {
					this.ids.push(item.id);
				});
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			//查询
			async Find() {
				var content = {
					page_num: this.condition.page_num,
					page_size: this.condition.page_size,
					id: this.condition.id,
					end_date: this.condition.start_date != null && this.condition.start_date != '' ?
					this.condition.start_date[1] : '',
					start_date: this.condition.start_date != null && this.condition.start_date != '' ?
					this.condition.start_date[0] : '',
					honour_id: this.manageList.id,
				}
				var data = await this.$globals.AxiosPost('tenderHonourCollection/getList', content);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			async payFind(){
				var url = "tenderHonourRecord/getList?tenderId=" + this.manageList.id;
				var data = await this.$globals.AxiosGet(url);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.payData = data;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			Plan() {
				this.showPlan = true
			},
			async PlanSave() {
				this.plan.honour_id = this.manageList.id;
				var data = await this.$globals.AxiosPost('tenderHonourCollection/add', this.plan);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showPlan = false;
						this.$message.success(data);
						this.plan = {};
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			Revise(e) {
				this.plan = e;
				this.showPlan = true;
				s
			},
			async ReviseSave() {
				this.plan.honour_id = this.manageList.id;
				var data = await this.$globals.AxiosPost('tenderBondCollection/update', this.plan);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showPlan = false;
						this.$message.success(data);
						this.plan = {};
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			Update(e) {
				this.register.id = e;
				this.showRegister = true;
			},
			async RegisterSave() {
				this.register.honour_id = this.manageList.id;
				this.register.applicant_id = this.$globals.user.staff_id;
				var data = await this.$globals.AxiosPost('tenderHonourCollection/planAdd', this.register);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showRegister = false;
						this.$message.success(data);
						this.register = {};
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			async Del(e) {
				var record = {
					ids: [e],
				};
				var data = await this.$globals.AxiosPost('tenderBondCollection/del', record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			handlePhotoSuccess(res, file) {
				this.register.collection_voucher = res.data.fileUrl;
			},
			close() {
				this.$emit('close')
			},

		},
		created() {

		},
	};
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 100%;
		height: 300px;
		display: block;
	}
</style>
<style scoped>
	.el-aside {
		height: 700px;
		background-color: #fbfbfb;
	}

	.text {
		width: 25%
	}

	.s {
		width: 260px;
		display: block;
		margin: 20px auto;
	}

	.bor {
		font-size: 20px;
	}

	.add {
		width: 90px;
		height: 35px;
		border-radius: 5px;
		color: #fff;
		background-color: #00724e;
	}

	.add2 {
		width: 90px;
		height: 35px;
		border-radius: 5px;
		color: #00724e;
		background-color: #fff;
		border: 1px solid #00724e;
	}

	.el-table {
		width: 850px;
		margin-top: 40px;
	}

	.el-pagination {
		width: 500px;
		text-align: center;
		margin-top: 30px;
	}

	.prev {
		width: 60px;
		height: 30px;
		position: absolute;
		top: 2px;
		left: 390px;
		color: #9094a0;
		background-color: #edf0f5;
		border: 0;
	}

	.ne {
		width: 60px;
		height: 30px;
		position: absolute;
		top: 2px;
		left: 460px;
		color: #9094a0;
		background-color: #edf0f5;
		border: 0;
	}

	.c {
		position: absolute;
		top: 1px;
		left: 560px;
	}

	.small {
		width: 50px;
		height: 20px;
	}

	.btn {
		width: 60px;
		height: 30px;
		position: absolute;
		background-color: #00724e;
		top: 5px;
		left: 680px;
		color: #fff;
		border-radius: 5px;
	}

	.input {
		width: 200px;
	}

	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.rz {
		margin-top: 20px;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 150px;
	}

	.el-dropdown /deep/ .el-button-group .el-button {
		width: 90px;
	}

	.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
		background-color: #00724e;
	}

	.el-table /deep/ thead {
		color: #000;
		font-weight: 700;
		background-color: #f0f0f0;
	}

	.bm {
		position: relative;
		height: 100px;
	}

	.el-button {
		background-color: #00724e;
		color: #fff;
		width: 100px;
	}

	.Time {
		margin-left: 80px;
	}

	.time {
		margin-bottom: 20px;
	}

	.money {
		margin-bottom: 50px;
	}

	.el-button--qian {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 13px;
		height: 40px;
		width: 80px;
	}

	.el-button--qian:focus,
	.el-button--qian:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// manage.vue?b5491836